import { DefaultEdge as DefaultEdgeComponent } from './DefaultEdge';
import { BranchEdge as BranchEdgeComponent } from './BranchEdge';
import { PhantomAddPathEdge as PhantomAddPathEdgeComponent } from './PhantomAddPathEdge';

export { DefaultEdgeComponent as DefaultEdge };
export { BranchEdgeComponent as BranchEdge };
export { PhantomAddPathEdgeComponent as PhantomAddPathEdge };

export const edgeTypes = {
	default: DefaultEdgeComponent,
	branch: BranchEdgeComponent,
	phantomAddPath: PhantomAddPathEdgeComponent,
};
